module.exports = __webpack_public_path__ + "img/env-general.ffc032e2.png";